var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSkypeColor = function SvgSkypeColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0.004,
    y: 0.064,
    fill: "#00AFF0",
    rx: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#skype-color_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.143,
    height: 17.143,
    x: 1.433,
    y: 1.492,
    fill: "#00AFF0",
    rx: 2.857
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#skype-color_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.035 13.133c-1.796 0-2.598-.884-2.598-1.547 0-.341.25-.578.595-.578.77 0 .568 1.106 2.003 1.106.733 0 1.139-.4 1.139-.809 0-.246-.12-.518-.605-.638l-1.596-.4c-1.286-.323-1.52-1.02-1.52-1.674 0-1.36 1.278-1.871 2.478-1.871 1.103 0 2.407.613 2.407 1.428 0 .35-.307.554-.648.554-.656 0-.535-.91-1.86-.91-.655 0-1.022.297-1.022.722 0 .426.514.562.963.664l1.177.262c1.29.29 1.618 1.047 1.618 1.76 0 1.106-.85 1.931-2.555 1.931m4.948-2.18-.013.06-.02-.106c.008.02.02.033.027.053q.08-.453.08-.916a5.053 5.053 0 0 0-1.484-3.579 5.1 5.1 0 0 0-1.604-1.082 4.5 4.5 0 0 0-1.933-.415c-.32 0-.644.03-.956.09l.053.027-.107-.014.053-.012a2.98 2.98 0 0 0-3.517.526 2.98 2.98 0 0 0-.876 2.12c0 .51.13 1.011.376 1.454l.01-.055.018.107-.028-.052q-.075.433-.076.873c0 .683.134 1.347.395 1.972.253.608.615 1.15 1.083 1.61a5.1 5.1 0 0 0 1.605 1.091 4.94 4.94 0 0 0 2.849.321l-.053-.028.107.02-.06.014c.447.254.949.39 1.47.39.796 0 1.544-.309 2.113-.877a2.98 2.98 0 0 0 .876-2.12c0-.508-.134-1.01-.38-1.458"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "skype-color_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.433 1.492h17.143v17.143H1.433z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "skype-color_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.647 4.707h10.714V15.42H4.647z"
  })))));
};
export default SvgSkypeColor;